import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import { saveRedirectAfterLogin } from '@/utils/functions';

export default function ProtectedRoute({ children }) {

  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    saveRedirectAfterLogin(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/signin" replace />;
  }

  return children;
}
